import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRoleAuthorization } from "../customHooks/useRoleAuthorization";
import { USER_ROLES } from "../constants/UserRoles";

const Aside = () => {
  const location = useLocation();
  const [menuAside, setMenuAside] = useState(false);

  const menuAsideClick = () => {
    document.body.classList.toggle("aside-full");
    setMenuAside(!menuAside);
  };

  return (
    <aside className="aside">
      <ul className="aside__list">
        <li className="aside__item">
          <Link
            to="home"
            className={`aside__link ${location.pathname == "/home" ? "is-active" : ""}`}
          >
            <span className="material-symbols-outlined">home</span>
            <span className="d-block navigation-text">Home</span>
          </Link>
        </li>
        <li className="aside__item">
          <Link
            to="tasks"
            className={`aside__link ${location.pathname == "/tasks" ? "is-active" : ""}`}
          >
            <svg viewBox="0 0 17 21" fill="none" className="svg-stroke">
              <path
                d="M5.5 3.5H3.5C2.96957 3.5 2.46086 3.71071 2.08579 4.08579C1.71071 4.46086 1.5 4.96957 1.5 5.5V17.5C1.5 18.0304 1.71071 18.5391 2.08579 18.9142C2.46086 19.2893 2.96957 19.5 3.5 19.5H13.5C14.0304 19.5 14.5391 19.2893 14.9142 18.9142C15.2893 18.5391 15.5 18.0304 15.5 17.5V5.5C15.5 4.96957 15.2893 4.46086 14.9142 4.08579C14.5391 3.71071 14.0304 3.5 13.5 3.5H11.5M5.5 3.5C5.5 4.03043 5.71071 4.53914 6.08579 4.91421C6.46086 5.28929 6.96957 5.5 7.5 5.5H9.5C10.0304 5.5 10.5391 5.28929 10.9142 4.91421C11.2893 4.53914 11.5 4.03043 11.5 3.5M5.5 3.5C5.5 2.96957 5.71071 2.46086 6.08579 2.08579C6.46086 1.71071 6.96957 1.5 7.5 1.5H9.5C10.0304 1.5 10.5391 1.71071 10.9142 2.08579C11.2893 2.46086 11.5 2.96957 11.5 3.5M5.5 12.5L7.5 14.5L11.5 10.5"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
            <span className="d-block navigation-text">Tasks</span>
          </Link>
        </li>
        <li className="aside__item">
          <Link
            to="patients"
            className={`aside__link ${location.pathname == "/patients" || location.pathname.startsWith("/patients/") ? "is-active" : ""}`}
          >
            <svg viewBox="0 0 21 19" fill="none" className="svg-stroke">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.5 16.4999C20.5 17.0519 20.053 17.4999 19.5 17.4999C18.947 17.4999 18.5 17.0519 18.5 16.4999C18.5 14.8459 17.154 13.4999 15.5 13.4999C14.817 13.4999 14.168 13.7339 13.644 14.1489C14.188 15.1449 14.5 16.2869 14.5 17.4999C14.5 18.0519 14.053 18.4999 13.5 18.4999C12.947 18.4999 12.5 18.0519 12.5 17.4999C12.5 14.7429 10.257 12.4999 7.5 12.4999C4.743 12.4999 2.5 14.7429 2.5 17.4999C2.5 18.0519 2.053 18.4999 1.5 18.4999C0.947 18.4999 0.5 18.0519 0.5 17.4999C0.5 13.6399 3.641 10.4999 7.5 10.4999C9.427 10.4999 11.173 11.2829 12.44 12.5459C13.309 11.8739 14.379 11.4999 15.5 11.4999C18.257 11.4999 20.5 13.7429 20.5 16.4999ZM15.5 6.5C16.052 6.5 16.5 6.949 16.5 7.5C16.5 8.051 16.052 8.5 15.5 8.5C14.948 8.5 14.5 8.051 14.5 7.5C14.5 6.949 14.948 6.5 15.5 6.5ZM15.5 10.501C17.154 10.501 18.5 9.15498 18.5 7.50098C18.5 5.84698 17.154 4.50098 15.5 4.50098C13.846 4.50098 12.5 5.84698 12.5 7.50098C12.5 9.15498 13.846 10.501 15.5 10.501ZM7.49994 2.49977C8.60294 2.49977 9.49994 3.39677 9.49994 4.49977C9.49994 5.60277 8.60294 6.49977 7.49994 6.49977C6.39694 6.49977 5.49994 5.60277 5.49994 4.49977C5.49994 3.39677 6.39694 2.49977 7.49994 2.49977ZM7.50017 8.5C9.70617 8.5 11.5002 6.706 11.5002 4.5C11.5002 2.294 9.70617 0.5 7.50017 0.5C5.29417 0.5 3.50017 2.294 3.50017 4.5C3.50017 6.706 5.29417 8.5 7.50017 8.5Z"
              />
            </svg>
            <span className="d-block navigation-text">Patients</span>
          </Link>
        </li>
        <li className="aside__item">
          <Link
            to="schedule"
            className={`aside__link ${location.pathname == "/schedule" ? "is-active" : ""}`}
          >
            <svg viewBox="0 0 21 21" fill="none" className="svg-stroke">
              <path d="M18.5 2.31818H17.5V0.5H15.5V2.31818H5.5V0.5H3.5V2.31818H2.5C1.4 2.31818 0.5 3.13636 0.5 4.13636V18.6818C0.5 19.6818 1.4 20.5 2.5 20.5H18.5C19.6 20.5 20.5 19.6818 20.5 18.6818V4.13636C20.5 3.13636 19.6 2.31818 18.5 2.31818ZM18.5 18.6818H2.5V8.68182H18.5V18.6818ZM18.5 6.86364H2.5V4.13636H18.5V6.86364Z" />
            </svg>
            <span className="d-block navigation-text">Schedule</span>
          </Link>
        </li>
        <li className="aside__item">
          <Link
            to="care-plans"
            className={`aside__link ${location.pathname == "/care-plans" ? "is-active" : ""}`}
          >
            <span className="material-symbols-outlined">prescriptions</span>
            <span className="d-block navigation-text">Care Plans</span>
          </Link>
        </li>
        {useRoleAuthorization([USER_ROLES.CLINICAL_LIAISON]) && (
          <li className="aside__item">
            <a
              href="https://convexityscientific.sharepoint.com/:f:/s/Clinical/IgDU7FSKv5t1RIev_0UG3KQ1ARyqHJwH_Gsr86TM7ibGEIE?e=W4rlwd"
              target="_blank"
              rel="noreferrer"
              className="aside__link"
            >
              <span className="material-symbols-outlined">menu_book</span>
              <span className="d-block navigation-text">Clinical Resources</span>
            </a>
          </li>
        )}
        <li className="aside__item">
          <Link
            to="eligible-patients"
            className={`aside__link ${location.pathname == "/eligible-patients" || location.pathname.startsWith("/eligibility/") ? "is-active" : ""}`}
          >
            <span className="material-symbols-outlined">person_add</span>
            <span className="d-block navigation-text">Eligibility</span>
          </Link>
        </li>
        <li className="aside__item">
          <Link
            to="reports"
            className={`aside__link ${location.pathname == "/reports" ? "is-active" : ""}`}
          >
            <span className="material-symbols-outlined">assessment</span>
            <span className="d-block navigation-text">Reports</span>
          </Link>
        </li>
        {useRoleAuthorization([USER_ROLES.ADMINISTRATOR]) && (
          <li className="aside__item">
            <Link
              to="command-center"
              className={`aside__link ${location.pathname == "/command-center" ? "is-active" : ""}`}
            >
              <span>
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="svg-stroke"
                >
                  <path d="M12.0735 9.44335C11.9399 10.6809 10.8289 11.5738 9.59144 11.4402C8.35395 11.3066 7.46098 10.1957 7.59457 8.9582C7.72816 7.7207 8.8391 6.82773 10.0766 6.96132C11.3106 7.09492 12.2071 8.20585 12.0735 9.44335ZM9.05707 17.7086C3.89965 17.4379 0.211758 12.85 0.855117 7.88593C1.24887 4.8414 3.1684 2.36992 5.74535 1.13593C11.4055 -1.57461 18.0395 2.45078 18.2153 8.75078C18.3594 13.9187 14.0528 17.9687 9.05707 17.7086ZM15.3817 11.3805C16.3625 7.23203 9.7391 4.14179 7.04262 3.14687C5.02113 5.12617 4.61332 9.77734 5.85434 15.2547C8.27309 15.8102 11.7993 14.3266 15.3817 11.3805Z" />
                </svg>
              </span>
              <span
                className={`d-block text-wrap text-start navigation-text ${!menuAside && "text-center"} `}
              >
                Command Center
              </span>
            </Link>
          </li>
        )}
        {useRoleAuthorization([USER_ROLES.ADMINISTRATOR]) && (
          <li className="aside__item">
            <Link
              to="administration"
              className={`aside__link ${["/administration/users", "/administration/user-roles"].includes(location.pathname) ? "is-active" : ""}`}
            >
              <span className="material-symbols-outlined">
                admin_panel_settings
              </span>
              <span className="d-block navigation-text">Admin</span>
            </Link>
          </li>
        )}
      </ul>
      <a
        className="aside__footer"
        href="#"
        onClick={() => menuAsideClick()}
      >
        <span className="material-symbols-outlined aside__footer-icon">
          {menuAside ? "arrow_back_ios" : "arrow_forward_ios"}
        </span>
      </a>
    </aside>
  );
};
export default Aside;
